// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"8446d3396fb1568bf0e1","339":"5dcaa225af3bc049878c"}[chunkId] + ".js";
};